import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import * as sessionStrageUtils from '../../../../utils/sessionStorage';
import { ChartType } from './GanttChartArea';

/**
 * ガントチャートエリアヘッダー部専用引数
 */
interface HeadderProps {
  /** チャート種別 */
  chartType: ChartType;
  /** チャート種別セット用関数 */
  setChartType: Dispatch<SetStateAction<ChartType>>;
  /** 子要素表示非表示切り替え用関数 */
  setShowChildList: Dispatch<SetStateAction<string[]>>;
  childProductionIdList: string[];
}

/**
 * ガントチャートエリアヘッダー部描画（※ガントチャート本体のヘッダーではない）
 */
function GanttChartAreaHeadder({ chartType, setChartType, setShowChildList, childProductionIdList }: HeadderProps) {
  // 言語情報
  const { t } = useTranslation();
  return (
    <div className="master-navi gantt">
      {/* 子日程表示非表示切り替えボタン */}
      <ul>
        <li>
          <button
            type="button"
            className="text-button"
            onClick={() => {
              setShowChildList(childProductionIdList);
            }}
          >
            <i className="fa-solid fa-circle-plus" />
            {t('子日程表示')}
          </button>
        </li>
        <li>
          <button
            type="button"
            className="text-button"
            onClick={() => {
              setShowChildList([]);
            }}
          >
            <i className="fa-solid fa-circle-minus" />
            {t('子日程非表示')}
          </button>
        </li>
      </ul>

      {/* チャート種別切り替えボタン */}
      <div className="mwdbtn">
        <button
          type="button"
          className={`text-button mwd-m ${chartType === 'Month' ? 'current' : ''}`}
          onClick={() => {
            setChartType('Month');
            sessionStrageUtils.set('ScheduleList.selectedChartType', 'Month');
          }}
        >
          {t('Month')}
        </button>
        <button
          type="button"
          className={`text-button mwd-w ${chartType === 'Week' ? 'current' : ''}`}
          onClick={() => {
            setChartType('Week');
            sessionStrageUtils.set('ScheduleList.selectedChartType', 'Week');
          }}
        >
          {t('Week')}
        </button>
        <button
          type="button"
          className={`text-button mwd-d ${chartType === 'Day' ? 'current' : ''}`}
          onClick={() => {
            setChartType('Day');
            sessionStrageUtils.set('ScheduleList.selectedChartType', 'Day');
          }}
        >
          {t('Day')}
        </button>
      </div>
    </div>
  );
}
export default GanttChartAreaHeadder;
